import { c as _c } from "react/compiler-runtime";
import type { ManagedSection } from '@onefootprint/request-types/dashboard';
import type { ManagedNode } from '../../store/types';
import { isControlVisible } from './config-path';
import ControlRenderer from './control-renderer';
type SectionRendererProps = {
  node: ManagedNode;
  section: ManagedSection;
};
const SectionRenderer = t0 => {
  const $ = _c(12);
  const {
    node,
    section
  } = t0;
  let t1;
  if ($[0] !== section.title) {
    t1 = section.title && <span className="text-caption-3 font-medium text-tertiary">{section.title}</span>;
    $[0] = section.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== node || $[3] !== section.controls) {
    let t3;
    if ($[5] !== node) {
      t3 = control => isControlVisible(control.visibleWhen, node.config);
      $[5] = node;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== node) {
      t4 = control_0 => <ControlRenderer key={control_0.path} node={node} control={control_0} />;
      $[7] = node;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t2 = section.controls.filter(t3).map(t4);
    $[2] = node;
    $[3] = section.controls;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className="flex flex-col gap-3">{t1}{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default SectionRenderer;